// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"PageTemplate__wrapper___35ihm","blurred":"PageTemplate__blurred___3QX4y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/PageTemplate/PageTemplate.scss
// module id = 679
// module chunks = 0